import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import { IUser } from 'bets.oddprovider.lib.common.ts/models'
import { UsersApiClient } from '../../apiClient/users'
import axios from '../../apiClient/axios'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'

export interface IUsersAction extends IDefaultAction {
  payload?: IUser[],
}

export interface IUsersState extends IDefaultState {
  payload?: IUser[],
}

const initState: IUsersState = {}

export const usersStateLoadFromApi = createAsyncThunk(
  'usersStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IUser>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {
    const apiResult: IApiClientResult<ApiResponseGetListData<IUser>> = await new UsersApiClient(axios).get({
      where: arg.where,
      sort: {name: 1}
    })

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()
    return apiResult
  }
)

export const usersSlice = createSlice({
  name: 'usersSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(usersStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(usersStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.data?.payload
    })
    builder.addCase(usersStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const {clear: clearUsers} = usersSlice.actions
export default usersSlice.reducer